export class ReportSummaries {
    constructor() {}
    public totalHours: number = 0;
    public rowCount: number = 0;
}
